import { Text } from "ilenia";
import React from "react";

import styles from "../../styles/sideNav.module.scss";
import { PrimaryNavArrows } from "./primaryNavArrows";
import { Badge } from "./primaryNavBadge";

//Render primary navigation link and icon
const PrimaryNavLinks = ({ menu }) => {
  const showNewBadge =
    Array.isArray(menu.subMenu) &&
    menu.subMenu.some((subMenu) => Array.isArray(subMenu?.subMenu) && subMenu.subMenu.some((item) => item.hasNewBadge));

  return (
    <span className={styles.sidebarLinks}>
      {menu.icon && <span className={styles.sidebarLinksIcon}>{menu.icon}</span>}
      <span className={styles.sidebarLinksText}>
        <Text id={`Sidebar.${menu.id}`} /> {menu.data && `(${menu.data})`}
      </span>
      {showNewBadge && <Badge />}
      {menu.subMenu && <PrimaryNavArrows />}
    </span>
  );
};

export default PrimaryNavLinks;
